import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Title from './Title';

import DnsIcon from '@mui/icons-material/Dns';

//function preventDefault(event) {
//  event.preventDefault();
//}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Account( { device, deviceStatus, setDeviceStatus, changeServer } ) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const myDate = new Date(deviceStatus.last_update);
  const mylocalDateTime = myDate.toLocaleDateString("fr") + " - " + myDate.toLocaleTimeString("fr")

  return (
    <React.Fragment>
      <Box sx={{ width: '100%' }}>
        <Title>Account</Title>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="Account tabs">
            <Tab label="Informations" {...a11yProps(0)} />
            <Tab disabled label="Settings" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Box sx={{ padding: 2}}>
            <TextField id="outlined-basic" label="name" variant="outlined" disabled value={deviceStatus.name} /> <br />
          </Box>
          <Box sx={{ padding: 2}}>
            <TextField id="outlined-basic" label="last update" variant="outlined" disabled value={mylocalDateTime} />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          Misc.
        </TabPanel>
      </Box>
    </React.Fragment>
  );

}

/*
          <Box sx={{ padding: 2}}>
            <FormControlLabel control={<Switch disabled defaultChecked={deviceStatus.connected}  />} label="Connected" />
          </Box>
          <Box sx={{ padding: 2}}>
            <FormControlLabel control={<Switch disabled defaultChecked={deviceStatus.authentified}  />} label="Authentified" />
          </Box>
*/